
import React from 'react';
import { TableRow } from '@/components/ui/table';
import { AttendeeRowCells } from './AttendeeRowCells';
import { useAttendeeRow } from './useAttendeeRow';
import { Attendee } from '@/types/attendee';
import PaymentConfirmDialog from '../payment/PaymentConfirmDialog';

interface AttendeeRowProps {
  attendee: Attendee;
  onCheckInSuccess: (attendee: Attendee, timestamp: string) => void;
  onDirectUpdate?: (code: string, updates: any) => Promise<any>;
  onSilentUpdate?: (attendee: Attendee) => void;
  showContribution?: boolean;
}

const AttendeeRow: React.FC<AttendeeRowProps> = ({
  attendee,
  onCheckInSuccess,
  onDirectUpdate,
  onSilentUpdate,
  showContribution = false
}) => {
  const {
    isPaid,
    isUpdating,
    localAttendance,
    localCheckedInAt,
    handlePaymentToggleRequest,
    handleDirectUpdate,
    showConfirmDialog,
    setShowConfirmDialog,
    pendingPaymentStatus,
    confirmPaymentChange,
    cancelPaymentChange
  } = useAttendeeRow(attendee, onSilentUpdate);

  return (
    <>
      <TableRow>
        <AttendeeRowCells
          attendee={attendee}
          isPaid={isPaid}
          isUpdating={isUpdating}
          localAttendance={localAttendance}
          localCheckedInAt={localCheckedInAt}
          onCheckInSuccess={onCheckInSuccess}
          onDirectUpdate={onDirectUpdate || handleDirectUpdate}
          onSilentUpdate={onSilentUpdate}
          handlePaymentToggleRequest={handlePaymentToggleRequest}
          showContribution={showContribution}
        />
      </TableRow>
      
      {/* Payment confirmation dialog */}
      <PaymentConfirmDialog
        attendee={attendee}
        isOpen={showConfirmDialog}
        setIsOpen={setShowConfirmDialog}
        pendingStatus={pendingPaymentStatus}
        onConfirm={confirmPaymentChange}
        onCancel={cancelPaymentChange}
      />
    </>
  );
};

export default React.memo(AttendeeRow);
